import axios from "axios";
import MailRegistryRecordDTO from "@/dto/mail/MailRegistryRecordDTO";
import {MAIL_REGISTRY_ENDPOINT, MAIL_ADVERTISING_UNSUBSCRIBE_ENDPOINT} from "@/constants/endpoints";
import authHeader from "@/services/auth-header";
import Page from "@/dto/taxation/Page";
import {MailTemplate} from "@/constants/MailConstants";
import QueryUtils from "@/utils/QueryUtils";

class MailService {

    getRegistry(template: MailTemplate | null, recipient: string | null, messageId: string | null, page: number, pageSize: number){
        const queryString = QueryUtils.buildQueryString(
            ["template", template],
            ["recipient", recipient],
            ["messageId", messageId],
            ["page", page],
            ["pageSize", pageSize]
        )
        return axios.get<Page<MailRegistryRecordDTO>>(MAIL_REGISTRY_ENDPOINT + queryString, {headers: authHeader()});
    }

    resendMessage(messageId: string){
        return axios.put(`${MAIL_REGISTRY_ENDPOINT}/${messageId}`, null, {headers: authHeader()});
    }

    unsubscribeFromAdvertising(token: string){
        const queryString = QueryUtils.buildQueryString(["token", token]);
        return axios.put(`${MAIL_ADVERTISING_UNSUBSCRIBE_ENDPOINT}${queryString}`);
    }

}

export default new MailService();